exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-footer{background-color:inherit}.fts-form-footer,.fts-form-footer .form-footer__l{display:flex;align-items:center}.fts-form-footer .form-footer__l:not(:last-child){margin-right:1rem}.fts-form-footer .form-footer__r{min-width:0;flex:1;display:flex;align-items:center;justify-content:flex-end}.fts-form-footer .form-footer__r>:not(:last-child){margin-right:.375rem}.fts-form-footer .form-btn-standard{flex-shrink:0}.fts-form-footer .form-activity-continue{margin-left:.5rem}", ""]);

// exports
